import { render, staticRenderFns } from "./MembershipChangeStatus.vue?vue&type=template&id=20a393b1&scoped=true&"
import script from "./MembershipChangeStatus.vue?vue&type=script&lang=js&"
export * from "./MembershipChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./MembershipChangeStatus.vue?vue&type=style&index=0&id=20a393b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a393b1",
  null
  
)

export default component.exports